<div class="c-richClub">
  <div class="c-richClub__container">
    <div class="c-richClub-icon"></div>
    <div class="c-richClub__info">
      <div class="c-richClub__text">
        <span class="text title">{{ 'home.modals.rich-club.bonus.title' | translate | uppercase }} </span>
        <span class="text subtitle"> {{ 'home.modals.rich-club.bonus.subtitle' | translate }}</span>
        <span></span>

        <div class="reward-container">
          @if (richClubData.reward && richClubData.reward.credits > 0) {
            <div class="coins-reward">
              <div class="coins-display-container">
                <slotcom-display [classes]="['c-display--rich-bonus']">
                  <div
                    displayIcon
                    displayIconPos="left"
                    [ngClass]="'c-display--coin'"></div>
                  {{ richClubData.reward.credits | number: '1.0-0' : ('common.culture' | translate) }}
                </slotcom-display>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="closeModal()"
      audioType="reward">
      <span class="label">
        {{ 'common.pick-up' | translate | uppercase }}
      </span>
    </slotcom-button>
  </div>
</div>
